import React, { useEffect, useState } from 'react';
import { DepartmentPersonnel, fetchDepartmentPersonnel } from '../services/dashboardApi';

const DepartmentPersonnelTable: React.FC = () => {
  const [data, setData] = useState<DepartmentPersonnel[]>([]);

  useEffect(() => {
    const loadData = async () => {
      const result = await fetchDepartmentPersonnel();
      setData(result);
    };
    loadData();
  }, []);

  return (
    <div className="card card-flush h-100 shadow-sm">
      <div className="card-body pt-2 pb-2" style={{ maxHeight: '750px', overflowY: 'auto' }}>
        <div className="table-responsive">
          <table className="table table-bordered mb-0">
            <thead className="sticky-top z-index-1">
              <tr style={{ backgroundColor: '#E8F5E9' }}>
                <th className="py-2 fw-bold text-gray-800 fs-7 text-center" style={{ borderRight: '1px solid #A5D6A7', width: '35%' }}>Name</th>
                <th className="py-2 fw-bold text-gray-800 fs-7 text-center" style={{ borderRight: '1px solid #A5D6A7', width: '45%' }}>Email</th>
                <th className="py-2 fw-bold text-gray-800 fs-7 text-center" style={{ width: '20%' }}>Extension</th>
              </tr>
            </thead>
            <tbody>
              {data?.map((department, deptIndex) => (
                <React.Fragment key={deptIndex}>
                  {/* Department Name Row */}
                  <tr style={{ backgroundColor: '#F5F5F5' }}>
                    <td colSpan={3} className="ps-3 py-2">
                      <span className="fw-bold text-gray-800 fs-6">
                        {department.departmentName}
                      </span>
                    </td>
                  </tr>
                  {/* Personnel Rows */}
                  {department.users.length>0? department.users.map((person, personIndex) => (
                    <tr key={`${deptIndex}-${personIndex}`} style={{ borderBottom: '1px solid #ddd' }}>
                      <td className="py-3 text-center" style={{ borderRight: '1px solid #ddd' }}>
                        <span className="text-gray-800 fs-7">{person.name}</span>
                      </td>
                      <td className="py-3 text-center" style={{ borderRight: '1px solid #ddd' }}>
                        <span className="text-gray-700 fs-7">{person.email}</span>
                      </td>
                      <td className="py-3 text-center">
                        <span className="text-gray-700 fs-7">{person.extension}</span>
                      </td>
                    </tr>
                  )):
                   <tr style={{ borderBottom: '1px solid #ddd' }}>
                      <td className="py-3 text-center" style={{ borderRight: '1px solid #ddd' }}>
                        <span className="text-gray-800 fs-7">-</span>
                      </td>
                      <td className="py-3 text-center" style={{ borderRight: '1px solid #ddd' }}>
                        <span className="text-gray-700 fs-7">-</span>
                      </td>
                      <td className="py-3 text-center">
                        <span className="text-gray-700 fs-7">-</span>
                      </td>
                    </tr>
                  }
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default DepartmentPersonnelTable;
